import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/home/news/lls_icon.png';
import _imports_1 from '../../../assets/images/home/news/qydt_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-77537927"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "press-center"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("b"), /*#__PURE__*/_createTextVNode("NEWS 新闻中心 "), /*#__PURE__*/_createElementVNode("b")]), /*#__PURE__*/_createElementVNode("p", null, "关于我们，最新动态在这里")], -1));

const _hoisted_3 = {
  class: "news-box"
};
const _hoisted_4 = {
  class: "tab-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "new-item"
};
const _hoisted_7 = {
  class: "left-img"
};
const _hoisted_8 = {
  class: "right-txt"
};
const _hoisted_9 = {
  class: "new-tit"
};
const _hoisted_10 = {
  class: "new-tag"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_13 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  const _component_svg_icon = _resolveComponent("svg-icon");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
    class: _normalizeClass(_ctx.num == 0 ? 'active' : ''),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.changeNum(0))
  }, "企业动态", 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.num == 1 ? 'active' : ''),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.changeNum(1))
  }, "行业新闻", 2)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.IndustryInformationList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "new-item-box",
      onClick: $event => _ctx.toPath(`/newsDetail?id=${item.code}`),
      key: item.code
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
      src: _ctx.imgUrl(item.coverFileUrl),
      alt: "",
      lazy: ""
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, [item.top == 1 ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      icon: "zhiding_icon",
      style: {
        "margin-right": "5px"
      }
    })) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(item.name), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, "作者：" + _toDisplayString(item.createName), 1), _hoisted_11, _createElementVNode("span", null, _toDisplayString(item.typeCode == "0" ? "企业动态" : "行业新闻"), 1), _hoisted_12, _createElementVNode("span", null, _toDisplayString(item.viewNum), 1)]), _createElementVNode("p", {
      class: "new-txt",
      innerHTML: item.contentsTrim
    }, null, 8, _hoisted_13)])])], 8, _hoisted_5);
  }), 128)), _ctx.IndustryInformationList ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    currentPage: _ctx.pageNo,
    "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => _ctx.pageNo = $event),
    "page-size": _ctx.pageSize,
    background: "",
    layout: "prev, pager, next",
    total: _ctx.total,
    onSizeChange: _ctx.handleSizeChange,
    onCurrentChange: _ctx.handleCurrentChange
  }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])) : _createCommentVNode("", true)])])]);
}